import React from 'react';
import PropTypes from 'prop-types';

import { FloatingScroll } from './ScrollDown.styled';

const ScrollDown = ({ dark, style }) => (
  <FloatingScroll dark={dark} className="d-none d-md-block" style={style}>
    <p>
      <i className="fal fa-angle-left" />
      <i className="fal fa-angle-left" />
      <i className="fal fa-angle-left" />
      &nbsp;&nbsp; Scroll Down
    </p>
  </FloatingScroll>
);

ScrollDown.propTypes = {
  dark: PropTypes.bool,
  style: PropTypes.object,
};

export default ScrollDown;
